import { BettoEmptyState } from "@pages/profile-v2/betto/components/BettoEmptyState";
import { isBettoHistoryTenant } from "@pages/profile-v2/betto/shared/bettoHistoryStyles";
import React from "react";
import { EmptyDescription, EmptyIcon, EmptyTitle, EmptyWrapper } from "./elements";

const AccountInsightsCompactEmpty = ({ title, description, translate }) => {
	if (isBettoHistoryTenant) {
		return <BettoEmptyState title={translate(description || title)} />;
	}

	return (
		<EmptyWrapper>
			<EmptyIcon />
			<EmptyTitle>{translate(title)}</EmptyTitle>
			<EmptyDescription>{translate(description)}</EmptyDescription>
		</EmptyWrapper>
	);
};

export default AccountInsightsCompactEmpty;
